export interface MatchAllResult {
    exact: string;
    group: string[];
}

export const matchAll = (regex: RegExp, text: string): MatchAllResult[] => {
    const globalRegex = new RegExp(regex, 'g');
    const output: MatchAllResult[] = [];
    let execArray: RegExpExecArray | null;

    while ((execArray = globalRegex.exec(text)) !== null) {
        output.push({
            exact: execArray[0],
            group: execArray.slice(1),
        });
    }

    return output;
};
